import React from 'react';
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
  useTheme,
} from '@material-ui/core';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import GridLayout from 'components/molecules/GridLayout';
import { ITabContentProps, PropertyFilterType } from '../configuration';
import { AppCheckbox } from 'components/atoms/StyledFormControls';
// import { Checkbox } from 'components/molecules/form_controls/';
import { HouseIcon } from '../icons';
import useStyles from '../styles';
import clsx from 'clsx';
import ProductFilterActions from '../store/actions';
import * as ProductFilterSelectors from '../store/selectors';
import { useDispatch } from 'react-redux';
import { IDataItems } from 'services/api/category';
import { IFiltersSelection } from '../store/reducer';
import { StateStatus } from 'redux/utils/common';
import { ISpecOption } from 'services/api/product';
import _ from 'lodash';
import Select from 'react-select';

interface IOption {
  id: string | number;
  label: string;
}

const TabPropertyType = (props: ITabContentProps) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const categories = ProductFilterSelectors.useGetCategory();
  const dataPropertyType =
    props.selections[PropertyFilterType.PropertyType].data;
  React.useEffect(() => {
    if (categories.data?.length === 0) {
      dispatch(ProductFilterActions.fetchCategoryAction());
    }
  }, []);
  const isChecked = (currentKey: string) => {
    var isChecked = false;
    for (let key of Object.keys(props.selections.PropertyType.data))
      if (key !== currentKey)
        isChecked =
          isChecked || _.get(props.selections.PropertyType.data, key, null);
    return isChecked;
  };
  const onValueChange = (
    key: string,
    value: number | number[] | string | null
  ) => {
    if (value === 'null') value = null;
    const valueReset: any = {};
    if (key === 'offerType') {
      valueReset.propertyType = null;
      valueReset.propertySubType = null;
    }
    if (key === 'propertyType') {
      valueReset.propertySubType = null;
    }
    dispatch(
      ProductFilterActions.setFiltersSelectionAction({
        ...props.selections,
        [PropertyFilterType.PropertyType]: {
          ...props.selections[PropertyFilterType.PropertyType],
          ...(isChecked(key) || value
            ? { isChecked: true }
            : { isChecked: false }),
          data: {
            ...props.selections[PropertyFilterType.PropertyType].data,
            [key]: value,
            ...valueReset,
          },
        },
      })
    );
  };
  return (
    <Box display={'flex'} flexDirection={'column'}>
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2 translationKey={''} defaultText={'Property Type'} />
      </Typography>
      <Typography
        style={{
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: theme.palette.text.secondary,
          marginBottom: '18px',
        }}
      >
        <TranslatedTextV2
          translationKey={''}
          defaultText={'Select one or more'}
        />
      </Typography>

      <Box>
        <FormControl component="fieldset">
          <FormLabel component="legend"></FormLabel>
          <RadioGroup
            value={dataPropertyType.offerType}
            onChange={(e) =>
              onValueChange('offerType', parseInt(e.target.value))
            }
            style={{
              display: 'flex',
              gap: 15,
              flexDirection: 'row',
            }}
          >
            {(categories.data?.length ? categories.data : [])
              .filter((value: ISpecOption) => !value.parentcategoryid)
              .map((value: ISpecOption) => {
                return {
                  value: value.id,
                  label: value.name,
                };
              })
              .map(({ label, value }, index) => (
                <FormControlLabel
                  key={index}
                  value={value}
                  control={<Radio color={'primary'} />}
                  label={label}
                />
              ))}
          </RadioGroup>
        </FormControl>
        <Box marginBottom={'12px'}></Box>
      </Box>
      <Typography
        style={{
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2 translationKey={``} defaultText="Property type" />
      </Typography>
      <Select
        placeholder={
          <TranslatedTextV2 translationKey={''} defaultText={'Select..'} />
        }
        styles={{
          // Fixes the overlapping problem of the component
          menu: (provided) => ({ ...provided, zIndex: 9999 }),
          menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
          control: (provided, state) => ({
            ...provided,
          }),
        }}
        getOptionLabel={(option: IOption) => option.label}
        getOptionValue={(option: IOption) => `${option.id}`}
        className="react-select"
        value={(categories.data?.length ? categories.data : [])
          .filter(
            (item) => item.id === parseInt(`${dataPropertyType.propertyType}`)
          )
          ?.map((value: ISpecOption) => {
            return {
              id: value.id,
              label: value.name,
            };
          })}
        onChange={(value) => {
          onValueChange('propertyType', value?.id || 'null');
        }}
        options={(categories.data?.length ? categories.data : [])
          .filter(
            (value) => value.parentcategoryid === dataPropertyType.offerType
          )
          .map((value: ISpecOption) => {
            return {
              id: value.id,
              label: value.name,
            };
          })}
      />
      <Box marginBottom={'12px'}></Box>
      <Typography
        style={{
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2 translationKey={``} defaultText="Sub type" />
      </Typography>
      <Select
        placeholder={
          <TranslatedTextV2 translationKey={''} defaultText={'Select..'} />
        }
        styles={{
          // Fixes the overlapping problem of the component
          menu: (provided) => ({ ...provided, zIndex: 9999 }),
          menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
          control: (provided, state) => ({
            ...provided,
          }),
        }}
        getOptionLabel={(option: IOption) => option.label}
        getOptionValue={(option: IOption) => `${option.id}`}
        className="react-select"
        value={(categories.data?.length ? categories.data : [])
          .filter((item) => dataPropertyType.propertySubType?.includes(item.id))
          ?.map((value: ISpecOption) => {
            return {
              id: value.id,
              label: value.name,
            };
          })}
        onChange={(value) => {
          onValueChange(
            'propertySubType',
            value.map((item) => item.id)
          );
        }}
        options={(categories.data?.length ? categories.data : [])
          .filter(
            (value) => value.parentcategoryid === dataPropertyType.propertyType
          )
          .map((value: ISpecOption) => {
            return {
              id: value.id,
              label: value.name,
            };
          })}
        isMulti
      />
      <Box marginBottom={'12px'}></Box>
      {categories.status === StateStatus.Pending ? (
        <Box
          style={{
            marginLeft: '50%',
          }}
        >
          <CircularProgress />
        </Box>
      ) : null}
    </Box>
  );
};

export default TabPropertyType;
